import { SelectOption } from "../common/general";

export const requestOptions: SelectOption[] = [
    {value: '1', item: '費用申請'},
    {value: '2', item: '備品申請'},
    {value: '3', item: '社員追加申請'},
    {value: '4', item: '退職者申請'},
];